import React, { useState, useContext, useCallback } from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  TextField,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CreateUserLink } from 'modules/Rest'
import { MessageContext } from './Contexts'
import { setModes } from 'modules/Utils'
import ActionButtons from './ActionButtons'

const useStyles = makeStyles({
  textField: {
    minWidth: 400,
  },
})

export function CreateLinkDialog({ mode, setMode, userTypeKey, getUsers, viewLink }) {
  const { messageDispatch } = useContext(MessageContext)

  const [shortenLink, setShortenLink] = useState(false)

  const createLink = useCallback(async (e, setMode) => {
    try {
      setMode('pending')
      const { data: { success, info, ...data } } = await CreateUserLink({ shorten_link: shortenLink, user_type: userTypeKey })
      if (success) {
        await setModes(setMode, ['completing', 1500, ''])
        viewLink(data)
      } else {
        throw new Error(info ? info : 'An error occurred')
      }
      getUsers()
    } catch (error) {
      setMode('')
      messageDispatch({ type: 'warning', payload: error.message })
    }
  }, [userTypeKey, shortenLink, getUsers, messageDispatch, viewLink])

  return <Dialog open={mode !== ''} aria-labelledby='add-dialog'>
    <DialogTitle>Create generic link</DialogTitle>
    <DialogContent>
      <FormControlLabel
        control={<Checkbox checked={shortenLink} onChange={event => setShortenLink(event.target.checked)}/>}
        label='Shorten link'
      />
    </DialogContent>

    <DialogActions>
      <ActionButtons
        mode={mode}
        setMode={setMode}
        action={createLink}
        cancel={(e, setMode) => setMode('')}
        actionTitle='Create link'
        neverShowEdit={true}
      />
    </DialogActions>
  </Dialog>
}

export function ViewLinkDialog({ link, mode, setMode }) {
  const classes = useStyles()

  const copyLink = useCallback((e, setMode) => {
    navigator.clipboard.writeText(link)
    setModes(setMode, ['pending', 750, 'completing'])
  }, [link])

  return <Dialog open={mode !== ''} aria-labelledby='add-dialog'>
    <DialogTitle>Link</DialogTitle>
    <DialogContent>
      <TextField label='Link' defaultValue={link} InputProps={{ readOnly: true }} fullWidth className={classes.textField} variant='standard' />
    </DialogContent>

    <DialogActions>
      <ActionButtons
        mode={mode}
        setMode={setMode}
        action={copyLink}
        cancel={(e, setMode) => setMode('')}
        actionTitle='Copy link to clipboard'
        cancelTitle='Close'
        neverShowEdit={true}
        alwaysShowCancel={true}
      />
    </DialogActions>
  </Dialog>
}
